import React, { Component, PropTypes } from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { Checkbox, Dialog, FlatButton, RadioButton, FontIcon, Chip } from 'material-ui';
import TextArea from '../../textarea';
import { validEmail } from '../../tc-ui/csv-upload/helperFunctions';
import { getStatus } from './template-list-for-RC';
import moment from 'moment';
import Dropzone from '../../extra/dropzone/dropzone';


class SendMessageRL extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  sendMessage = () => {
    const {
      sendMessage,
      rateDocIds,
      requestSigsChecked,
      subject,
      message,
      sentByEmail,
      emails,
      crId,
      contractId,
      historyFeedId,
      who,
      inActivityFeed,
      isRateContract,
      leanFiles,
    } = this.props;
    sendMessage({
      emails,
      rateDocIds,
      requestSigsChecked,
      subject,
      message,
      sentBy: sentByEmail,
      crId,
      who,
      contractId,
      historyFeedId,
      inActivityFeed,
      isRateContract,
      leanFiles,
    });
  };
  submitRates = () => {
    const { submitRates, rateDocIds, subject, message, crId, who } = this.props;
    submitRates({
      rateDocIds,
      subject,
      message,
      crId,
      who,
    });
  }
  render() {
    const {
      // inActivityFeed,
      sentByEmail,
      emailAlias,
      // buyerEmail,
      // supplierEmails,
      sending,
      sent,
      cancel,
      who,
      emails,
      subject,
      message,
      updateProps,
      requestSigsChecked,
      submitRatesChecked,
      templates,
      rateDocIds,
      // defaultSubject,
      // defaultMessage,
      open,
      leanFiles,
      isRateContract,
      locationName,
    } = this.props;
    const templatesToShow = templates
      .filter(t => submitRatesChecked ? getStatus(t) === '100% completed' : t.originalContractId);
    const isDL = sentByEmail === 'admin@tourconnect.com'
      || sentByEmail === 'dl@tourconnect.com';
    const attachFile = files => {
      updateProps({
        leanFiles: [
          ...leanFiles,
          ...files,
        ],
      });
    };
    const deleteFile = i => () => updateProps({
      leanFiles: R.remove(i, 1, leanFiles),
    });
    return (
      <Dialog
        open={open}
        title={who === 'DL' ? 'Send Message to TourConnect Data Team' : 'Send Message to Partner'}
        onRequestClose={cancel}
        autoScrollBodyContent
        actions={sent ? [
          <FlatButton
            key="dismiss"
            label="Dismiss"
            secondary
            onClick={cancel}
          />,
        ] : [
          isRateContract ? (
            <div style={{ float: 'left', marginTop: '8px' }} key="locName">
              Regarding Contract: {locationName}
            </div>
          ) : null,
          <FlatButton
            key="cancel"
            label="cancel"
            primary
            onClick={cancel}
          />,
          <FlatButton
            key="send"
            label={submitRatesChecked ? 'Submit' : 'Send'}
            secondary
            disabled={
              sending
              || !emails.filter(str => validEmail(str)).length
              || !subject
              || !message
              || ((requestSigsChecked || submitRatesChecked) && !rateDocIds.length)}
            onClick={submitRatesChecked ? this.submitRates : this.sendMessage}
          />,
        ].filter(Boolean)}
      >
        {
          (() => {
            if (sent) {
              return (
                <div style={{ margin: '1em auto' }}>
                  {submitRatesChecked ? 'Rate Submitted' : 'Message Sent!'}
                </div>
              );
            }
            return (
              <div>
                {
                  // !submitRatesChecked && !inActivityFeed && (
                  //   <div style={{ marginTop: '1em' }}>
                  //     <label>Who would you like to send message to?</label>
                  //     {
                  //       isDL ? (
                  //         <RadioButton
                  //           label="Buyer"
                  //           checked={who === 'Buyer'}
                  //           onCheck={() => updateProps({
                  //             who: 'Buyer',
                  //             emails: [buyerEmail],
                  //             subject: defaultSubject,
                  //             message: defaultMessage,
                  //           })}
                  //         />
                  //       ) : (
                  //         <RadioButton
                  //           label="TourConnect Data Conversion Team"
                  //           checked={who === 'DL'}
                  //           onCheck={() => updateProps({
                  //             who: 'DL',
                  //             emails: ['dl@tourconnect.com'],
                  //             subject: defaultSubject,
                  //           })}
                  //         />
                  //       )
                  //     }
                  //     <RadioButton
                  //       label="Supplier"
                  //       checked={who === 'Supplier'}
                  //       onCheck={() => updateProps({
                  //         who: 'Supplier',
                  //         emails: supplierEmails,
                  //         subject: defaultSubject,
                  //         ...(isDL ? {
                  //           message: defaultMessage,
                  //         } : {})
                  //       })}
                  //     />
                  //   </div>
                  // )
                }
                {
                  Boolean(who) && (
                    <div style={{ marginTop: '1em' }}>
                      {
                        who === 'DL'
                        ? (
                          <div>
                            <label>To: dl@tourconnect.com</label>
                            <br/>
                            <br/>
                          </div>
                        )
                        : (
                          <div>
                            <label>Please separate recipients with a semicolon:</label>&nbsp;&nbsp;<small style={{ color: '#ff4081' }}>Required</small>
                            <br/>
                            <TextArea
                              value={emails.join(';')}
                              onChange={e => updateProps({ emails: e.target.value.split(';') })}
                              rows={2}
                              error={emails.some(str => str && !validEmail(str)) ? 'Please enter valid email addresses' : ''}
                            />
                          </div>
                        )
                      }
                      <label>Please enter a subject here:</label>&nbsp;&nbsp;<small style={{ color: '#ff4081' }}>Required</small>
                      <br/>
                      <TextArea
                        value={subject || ''}
                        onChange={e => updateProps({ subject: e.target.value })}
                        rows={1}
                      />
                      <label>Message:</label>&nbsp;&nbsp;<small style={{ color: '#ff4081' }}>Required</small>
                      <TextArea
                        value={message || ''}
                        onChange={e => updateProps({ message: e.target.value })}
                        rows={4}
                      />
                      <div style={{ margin: '2em 0' }}>
                        <label>File Attachments: </label>
                        {
                          leanFiles.map((file, i) => (
                            <Chip
                              key={i}
                              labelStyle={{ lineHeight: '24px', whiteSpace: 'pre-wrap' }}
                              style={{ marginBottom: '8px' }}
                              onRequestDelete={deleteFile(i)}
                            >
                              {file.name}
                            </Chip>
                          ))
                        }
                        <Dropzone
                          style={{ border: '1px dotted #bfbfbf', padding: '12px 8px', color: '#bfbfbf', fontSize: '12px', minHeight: '50px', width: '95%' }}
                          onDrop={attachFile}
                        >
                          <FontIcon className="tc-icon-attach_file" color="#bfbfbf" style={{ fontSize: '14px', top: '2px', marginRight: '5px' }} />
                          Attach files by dragging & dropping or <span style={{ color: '#00b3cf', cursor: 'pointer' }}>selecting them.</span>
                        </Dropzone>
                      </div>
                      <label>Sent By: {sentByEmail}</label>
                      {
                        Boolean(emailAlias && !isDL) && (
                          <label style={{ display: 'block' }}>Email Display Name: {emailAlias}</label>
                        )
                      }
                    </div>
                  )
                }
                {
                  who === 'Supplier' && Boolean(templatesToShow.length) && (
                    <Checkbox
                      style={{ marginTop: '2em' }}
                      label="Request Signature"
                      checked={Boolean(requestSigsChecked)}
                      onCheck={(_, checked) => updateProps({ requestSigsChecked: checked })}
                    />
                  )
                }
                {
                  Boolean(who === 'Supplier' || submitRatesChecked) && Boolean(templatesToShow.length) && (
                    <div style={{ margin: '1em 0 2em 0' }}>
                      <label style={{ color: 'rgba(0, 0, 0, 0.77)' }}>
                        Please Select Rate Sheets
                        {requestSigsChecked || submitRatesChecked ? (<small style={{ color: '#ff4081' }}>&nbsp;&nbsp;Required</small>) : <span/>}
                      </label>
                      <br/>
                      <br/>
                      {
                        Boolean(templatesToShow.length) && (
                          <Checkbox
                            checked={rateDocIds.length === templatesToShow.length}
                            onCheck={(_, checked) => updateProps({
                              rateDocIds: checked
                                ? templatesToShow.map(o => o.originalContractId)
                                : [],
                            })}
                            label="SELECT ALL"
                          />
                        )
                      }
                      {
                        templatesToShow
                          .sort((a, b) => (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()))
                          .map(t => (
                            <div
                              key={t._id}
                              className="flex-center"
                              style={{ width: '100%', borderBottom: '1px solid #e0e0e0' }}
                            >
                              <Checkbox
                                checked={rateDocIds.indexOf(t.originalContractId) > -1}
                                onCheck={(_, checked) => updateProps({
                                  rateDocIds: R.uniq(
                                    checked
                                      ? [...rateDocIds, t.originalContractId]
                                      : rateDocIds.filter(id => id !== t.originalContractId)
                                  ),
                                })}
                                style={{ width: '40px' }}
                              />
                              <div style={{ width: '50%' }}>
                                Rate Sheet for {t.locationName}
                              </div>
                              <small style={{ marginLeft: '16px' }}>
                                {moment.utc(t.startDate).format('DD MMM YYYY')} - {moment.utc(t.endDate).format('DD MMM YYYY')}
                              </small>
                              <div
                                style={{ marginLeft: '16px', minWidth: '120px', textAlign: 'right' }}
                              >
                                {getStatus(t)}
                              </div>
                            </div>
                          ))
                      }
                    </div>
                  )
                }
              </div>
            );
          })()
        }
      </Dialog>
    );
  }
}

SendMessageRL.propTypes = {
  inActivityFeed: PropTypes.bool,
  historyFeedId: PropTypes.string,
  open: PropTypes.bool,
  crId: PropTypes.string,
  contractId: PropTypes.string,
  sentByEmail: PropTypes.string,
  emailAlias: PropTypes.string,
  supplierEmails: PropTypes.array,
  buyerEmail: PropTypes.string,
  updateProps: PropTypes.func,
  sending: PropTypes.bool,
  sent: PropTypes.bool,
  cancel: PropTypes.func,
  who: PropTypes.string,
  emails: PropTypes.array,
  subject: PropTypes.string,
  message: PropTypes.string,
  requestSigsChecked: PropTypes.bool,
  submitRatesChecked: PropTypes.bool,
  templates: PropTypes.array,
  rateDocIds: PropTypes.array,
  sendMessage: PropTypes.func,
  submitRates: PropTypes.func,
  defaultSubject: PropTypes.string,
  defaultMessage: PropTypes.string,
  isRateContract: PropTypes.bool,
  locationName: PropTypes.string,
  leanFiles: PropTypes.array,
};

export default connect(({ user, dummyAcct, contracting }, { inActivityFeed }) => {
  const contactsOfThePartner = contracting.contractActivitiesProducts.getIn(['leftNav', 'partners', 0, 'contacts']);
  const isRateContract = Boolean(contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']));
  return {
    sentByEmail: inActivityFeed
      ? user.getIn(['user', 'email'])
      : (user.get('realActorEmail') || user.getIn(['user', 'email'])),
    emailAlias: user.get('emailAlias'),
    buyerEmail: inActivityFeed ? '' : dummyAcct.inCR.buyerEmail,
    supplierEmails: contactsOfThePartner ? contactsOfThePartner.toJS().map(o => o.email) : dummyAcct.inCR.supplierEmails,
    templates: isRateContract ? [] : dummyAcct.inCR.dummySupplierForCR.templates,
    crId: isRateContract ? contracting.contractActivitiesProducts.getIn(['leftNav', 'versions', 0]) : dummyAcct.inCR.crId,
    contractId: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
    historyFeedId: contracting.contractActivitiesProducts.getIn(['leftNav', 'historyFeedId']),
    isRateContract,
    locationName: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationName']),
    ...dummyAcct.sendMsg,
  };
}, ({
  cancel: () => ({ type: '{rl-send-message} CANCEL_SEND_MESSAGE' }),
  updateProps: payload => ({ type: '{rl-send-message} UPDATE_PROPS', payload }),
  sendMessage: payload => ({ type: '{rl-send-message} SEND_MESSAGE', payload }),
  submitRates: payload => ({ type: '{rl-send-message} SUBMIT_RATES_AS_DL', payload }),
}))(SendMessageRL);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/send-message.jsx